import { getFetchedDataPayload } from '../../../utils/fetched-data/get-fetched-data-payload';
import { salesDataDomainStore } from '../../sales-data/store';
import { getBillingRecurrence } from '../../sales-data/types/subscription-billing-recurrence';
import { hasValidValuesForFilter } from './has-valid-values-for-filter';
export const getFilteredSubscriptionBillingOptions = (filter) => {
    const billingOptions = Object.values(getFetchedDataPayload(salesDataDomainStore.data.subscriptionBillingOptionsById, {}));
    return billingOptions.filter(option => {
        if (!filter.baseData.includes(option.id))
            return false;
        const isValidBillingPeriod = hasValidValuesForFilter(filter.sections.billingPeriod, [
            option.billingPeriodInMonths
        ]);
        const isValidBillingRecurrence = hasValidValuesForFilter(filter.sections.billingRecurrence, [
            getBillingRecurrence(option.isRecurring)
        ]);
        const isValidSubscriptionId = hasValidValuesForFilter(filter.sections.subscription, [option.subscriptionId]);
        return isValidBillingPeriod && isValidBillingRecurrence && isValidSubscriptionId;
    });
};
